import { toTypedRxJsonSchema } from 'rxdb';
import type { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema } from 'rxdb';

export interface PriceTier {
  quantity: number;        // e.g.: 3, 6, 10
  label: string;           // e.g.: "+x3", "+x6", "Pack 10"
  total_price: number;     // e.g.: 50.00
}

export const serviceSchemaLiteral = {
  title: 'service',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: { type: 'string', maxLength: 100 },
    concept: { type: 'string', maxLength: 200 },
    category_id: { type: ['string', 'null'], maxLength: 100 },
    currency_price: { type: 'number' },
    commission_percentage: { type: 'number' },
    branch_id: { type: ['string', 'null'], maxLength: 100 },
    duration_minutes: { type: ['number', 'null'] },
    description: { type: ['string', 'null'], maxLength: 500 },
    is_active: { type: 'boolean' },
    price_tiers: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          quantity: { type: 'number' },
          label: { type: 'string' },
          total_price: { type: 'number' },
        },
        required: ['quantity', 'label', 'total_price'],
      },
    },
    // --- Control ---
    created_at: { type: 'string', maxLength: 50 },
    updated_at: { type: 'string', maxLength: 50 },
    is_deleted: { type: 'boolean' },
    
    last_modified_by: { type: ['string', 'null'], maxLength: 100 },
  },
  required: ['id', 'concept', 'currency_price', 'commission_percentage', 'price_tiers', 'updated_at', 'is_deleted', 'is_active'],
  indexes: ['is_deleted', 'updated_at'],
} as const;

const schemaTyped = toTypedRxJsonSchema(serviceSchemaLiteral);
export type ServiceDocType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const serviceSchema: RxJsonSchema<ServiceDocType> = serviceSchemaLiteral;

